/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

export const DefaultLoaderSpinner: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div
      className={`player-default-loader ${className || ""}`}
      role="status"
      aria-label="Loading"
    >
      <div className="player-default-loader__spinner" />
    </div>
  );
};
